import round from 'helpers/mathRound';
import { getAlleDiscount } from '../helpers';
import { getDiscount } from './getDiscount';


export const calculateTotals = (selectedItems = [], products, selectedPlan = []) => {
  if (!products) {
    return {
      subtotal: 0,
      grandTotal: 0,
      discountTotal: 0,
      totalAdditionalSubscriptionPrice: 0,
      totalSubscription: 0,
    };
  }

  const calculateItemTotals = (acc, item) => {
    const {
      sku,
      qty,
      product_option: {
        extension_attributes: {
          subscription_id,
          quotepro_discounts: customQuoteproDiscounts
        },
      },
      price: updatedPrice
    } = item;

    const {
      savings = 0,
      price = 0,
      subscription_active,
      subscription_options,
      additional_subscription_price = 0,
      quotepro_discounts,
      name = ''
    } = products.find((product) => product.sku === sku) || [];

    const productAlleData = { sku, name };
    const itemPrice = updatedPrice || price;

    const dataForDiscount = {
      savings: Number(savings),
      discount_options: quotepro_discounts && quotepro_discounts !== '[]' ? JSON.parse(quotepro_discounts) : [customQuoteproDiscounts],
      itemPrice
    };

    const isAlleSKU = sku.includes('bdsku');
    const itemDiscount = isAlleSKU
      ? round(getAlleDiscount(productAlleData)) || 0
      : round(getDiscount(item, dataForDiscount)) || 0;

    let itemRegularPrice = itemPrice ? itemPrice * qty : (itemPrice - Number(savings)) * qty;
    let itemSubscriptionPrice = 0;

    if (subscription_id) {
      const subscriptionData = subscription_options?.find((s) => Number(s.id) === Number(subscription_id));
      itemSubscriptionPrice = qty * round(subscriptionData?.installment_price + subscriptionData?.adjustment_price);
      const isSubscriptionActive = subscription_active === '1';
      const isNullPrice = subscriptionData?.installment_price === null && subscriptionData?.adjustment_price === null;

      if (isSubscriptionActive && !isNullPrice && itemPrice == 0) {
        itemRegularPrice = qty * round(subscriptionData?.installment_price + subscriptionData?.adjustment_price + Number(savings));
      }
    }

    const selectedPlanQuoteDiscount = selectedPlan.find((planItem) => planItem.selectedItemIds.includes(item._id))?.quoteDiscount;

    let quoteDiscount = 0;

    if (selectedPlanQuoteDiscount?.price_type && selectedPlanQuoteDiscount?.price) {
      const { price_type, price } = selectedPlanQuoteDiscount;
      quoteDiscount = price_type === 'fixed'
        ? Math.abs(price)
        : Math.abs((price * (itemRegularPrice - itemDiscount) / 100));
    }

    const itemGrandTotal = itemRegularPrice - itemDiscount - quoteDiscount;

    return {
      ...acc,
      subtotal: acc.subtotal += Number(itemRegularPrice),
      grandTotal: acc.grandTotal += Number(itemGrandTotal),
      totalAdditionalSubscriptionPrice: acc.totalAdditionalSubscriptionPrice += Number(additional_subscription_price),
      discountTotal: acc.discountTotal += Number(itemDiscount),
      totalSubscription: acc.totalSubscription += Number(itemSubscriptionPrice),
      quoteDiscount: acc.quoteDiscount = selectedPlan?.length > 1 ? Number(quoteDiscount) + acc.quoteDiscount : Number(quoteDiscount)
    };
  };

  const initialTotals = {
    subtotal: 0,
    grandTotal: 0,
    discountTotal: 0,
    quoteDiscount: 0,
    totalAdditionalSubscriptionPrice: 0,
    totalSubscription: 0,
  };

  const totals = selectedItems.reduce(calculateItemTotals, initialTotals);
  return totals;
};
